/**
 * Extracts the relative URL by removing the protocol and domain from the given URL.
 *
 * @param url - The URL from which the protocol and domain should be removed.
 * @returns The relative URL without the protocol and domain.
 *
 * @example
 * ```typescript
 * const url = "https://www.example.com/path/to/resource";
 * const relativeUrl = getRelativeUrlWithoutProtocolAndDomain(url);
 * console.log(relativeUrl); // Output: "/path/to/resource"
 * ```
 */
export const getRelativeUrlWithoutProtocolAndDomain = (url: string): string => {
  // Regular expression to match and capture the protocol, optional www., and domain part of the URL
  const domainRegex = /^(https?:\/\/)(?:www\.)?([^/]+)/i;
  return url.replace(domainRegex, '');
};
